import { getTime } from 'date-fns';
import { selfServiceApiClient } from 'config/selfServiceApi';
import { getMe } from 'services/ApiService';

export const getBookings = (page, limit = 24) => {
  return selfServiceApiClient(
    `/api/self-service/bookings?_sort=outbound&_page=${page}&_results=${limit}`,
  );
};

export const contactAgent = async ({ message, assignee = null, context = null, reference = null }) => {
  const { data: authUser } = await getMe();

  const data = {
    isNew: true,
    description: message,
    priority: null,
    assignee,
    visitor: authUser,
    type: 'Uncategorised',
    due: {
      timestamp: getTime(new Date()),
      zone: 'UTC',
    },
  };

  const headers = {
    'Content-Type': 'application/json',
  };

  let url = '/api/self-service/task';

  if (reference && context) {
    url += `?reference=${encodeURIComponent(reference)}&type=${encodeURIComponent(context)}`;
  }

  return selfServiceApiClient.post(
    url,
    JSON.stringify(data),
    {
      withCredentials: true,
      headers,
    },
  );
};
